import { SubscriptionSize } from "../SubscriptionSize.js";

export const subscriptionSizeToWeightMap = {
	[SubscriptionSize.G250]: 250,
	[SubscriptionSize.G250x2]: 250,
	[SubscriptionSize.Kg1]: 1000,
} as const satisfies Record<SubscriptionSize, number>;
